// @ts-nocheck
import { useState, useRef, useReducer, useEffect } from 'react';
import { Dialog } from "primereact/dialog";
import { Card } from 'primereact/card';
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { ListBox } from 'primereact/listbox';
import { Divider } from 'primereact/divider';
import "../assets/functionalComponents/_dialog.scss"
import "../assets/functionalComponents/_dataItem.scss"
import "../assets/functionalComponents/ScrollPanelDemo.css"

export const FluidComponents =  (props) => {
    const toast = useRef(null);
    const [selectedEvent, setSelectedEvent] = useState(null);
    const [addFluid, setAddFluid] = useState(null);
    const [timeEventList, setTimeEventList] = useState([]);
    const [, forceUpdate] = useReducer(num => num + 1, 0);
    // 提前輸入可分析之流體資料
    const eventList = [
        {
            name: '洋流分析 (2016/11/20 ~ 2016/11/22)',
            time: ["2016112000", "2016112006", "2016112012", "2016112018", "2016112100", "2016112106", "2016112112", "2016112118", "2016112200"]
        },
        {
            name: '測試用',
            time: ["2016112000", "2016112006", "2016112012", "2016112018", "2016112100", "2016112106", "2016112112", "2016112118", "2016112200"]
        },
    ];

    
    const showFluid = () => {

        if (selectedEvent === null) {
            toast.current.show({ severity: 'warn', summary: '提醒資訊', detail: '尚未選擇流體分析列表，請選擇後再行點擊!' });
            return;
        }

        let listLength = selectedEvent.time.length - 1;
        // 透過提前輸入之流體資料取得起始時間(年月日時)
        let startYear  = selectedEvent.time[0].substring(0, 4);
        let startMonth = selectedEvent.time[0].substring(4, 6);
        let startDay   = selectedEvent.time[0].substring(6, 8);
        let startHour  = selectedEvent.time[0].substring(8, 10);
        // 透過提前輸入之流體資料取得結束時間(年月日時)
        let endYear    = selectedEvent.time[listLength].substring(0, 4);
        let endMonth   = selectedEvent.time[listLength].substring(4, 6);
        let endDay     = selectedEvent.time[listLength].substring(6, 8);
        let endHour    = selectedEvent.time[listLength].substring(8, 10);

        let startTime = new Date(startYear, startMonth - 1, startDay, startHour);
        let endTime = new Date(endYear, endMonth - 1, endDay, endHour);
        // 更新時間軸起始及結束時間
        window.widgetTimeline.updateParameter({ startTime: startTime - 500000, stopTime: endTime + 500000});
        window.widgetTimeline.addTimeBlock({
            start: startTime,
            end: endTime,
            color: 'red'
        });
        // 設定時間事件
        timeEvent();
        // 用以設定按鈕disable
        setAddFluid(true);
        // 時間軸啟動
        window.widgetTimelinePlayer.play();
        forceUpdate();
    }


    const timeEvent =  () => {

        let list = [];

        for (let i = 0; i < selectedEvent.time.length - 1; i++) {
            // 透過提前輸入之流體資料取得起始時間(年月日時)
            let startYear  = selectedEvent.time[i].substring(0, 4);
            let startMonth = selectedEvent.time[i].substring(4, 6);
            let startDay   = selectedEvent.time[i].substring(6, 8);
            let startHour  = selectedEvent.time[i].substring(8, 10);
            // 透過提前輸入之流體資料取得結束時間(年月日時)
            let endYear    = selectedEvent.time[i+1].substring(0, 4);
            let endMonth   = selectedEvent.time[i+1].substring(4, 6);
            let endDay     = selectedEvent.time[i+1].substring(6, 8);
            let endHour    = selectedEvent.time[i+1].substring(8, 10);

            let startTime = new Date(startYear, startMonth - 1, startDay, startHour);
            let endTime   = new Date(endYear, endMonth - 1, endDay, endHour);
            // 透過前兩項資料設定時間事件
            let timeEventNum = window.main.OView.addTimeEvent({
                start: startTime,
                end: endTime,
                onEnter: function () {
                    // 呼叫流體資料
                    updateWind(selectedEvent.time[i]);
                },
                onLeave: function () {
                    // 關閉流體資料
                    closeFluid();
                }
            })
            // 將回傳之時間事件index儲存，以便後續刪除時間事件使用
            list = timeEventList;
            list.push(timeEventNum);
        }
        setTimeEventList(list);
    }

    const updateWind = (name) => {

        let fluidModule = window.main.OView.getModule("fluid");
        // 呼叫流體資料
        getJSON('wind/' + name + '.json', function (windData) {
            const windImage = new Image();
            windData.image = windImage;
            windImage.src = 'wind/' + name + '.png';
            windImage.onload = function () {
                fluidModule.setFluidDataByParam(windData);
                window.main.OView.updateScreen();
            };
        });

    }
 
    const getJSON = (url, callback) => {
        const xhr = new XMLHttpRequest();
        xhr.responseType = 'json';
        xhr.open('get', url, true);
        xhr.onload = function () {
            if (xhr.status >= 200 && xhr.status < 300) {
                callback(xhr.response);
            } else {
                throw new Error(xhr.statusText);
            }
        };
        xhr.send();
    }

    const closeFluid = () => {
        // 關閉流體資料
        let fluidModule = window.main.OView.getModule("fluid");
        fluidModule.release();
        fluidModule.removeFluidData();
    }

    const closeAll = () => {
        // 將流體分析增建的時間事件全部刪除
        for (let i = 0; i < timeEventList.length; i++) {
            window.main.OView.removeTimeEvent(timeEventList[i]);
        }

        let fluidModule = window.main.OView.getModule("fluid");
        fluidModule.release();
        fluidModule.removeFluidData();
        // 移除時間軸方格顯示
        window.widgetTimeline.removeAllTimeBlock();
        // 時間軸回歸
        window.widgetTimelinePlayer.reset();
        window.widgetTimelinePlayer.stop();
        setAddFluid(false);
        forceUpdate();
    }
    
    return (
        <div>
            <Toast ref={toast} />
            <Dialog header="流體分析" visible={props.Fluid} modal={false} keepInViewport={false} onHide={() => props.onHide('Fluid')} style={{ width: "25%" }}>
                <Card subTitle='流體分析列表'>
                    <ListBox value={selectedEvent} options={eventList} onChange={(e) => setSelectedEvent(e.value)} filter optionLabel="name" style={{ width: '100%' }} listStyle={{ height: '250px' }}/>
                    <Divider />
                    <div className="field grid">
                        <div className="col-12 md:col-6">
                            <Button label="播放" icon="pi pi-caret-right" className="p-button-raised" onClick={() => { showFluid() }} disabled={addFluid} style={{ width: "100%" }} /> 
                        </div>
                        <div className="col-12 md:col-6">
                            <Button label="刪除" icon="pi pi-times" className="p-button-raised" onClick={() => { closeAll() }} style={{ width: "100%" }} /> 
                        </div>
                    </div>
                </Card>
            </Dialog>
        </div>
    )
}